import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-fields',
  templateUrl: './formly-fields.component.html',
  styleUrl: './formly-fields.component.scss',
})
export class FormlyFieldsComponent extends FieldType {}
